import { DisplayText } from './displayText';

export class EventsActionSort {
    column: DisplayText;
    order: 'ASC' | 'DESC';

    constructor() {
        this.column = null;
        this.order = 'DESC';
    }

    sortIsDefault() {
        if (this.column.key === 'DATE' && this.order === 'DESC') {
            return true;
        }
    }
}
